/*eslint react/no-deprecated: 0*/
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';
import { Row, Col } from 'reactstrap';

import { Field, reduxForm} from 'redux-form/immutable';

import { CancelarButtonC } from 'modules/general/component';

import * as generalActions from 'modules/general/action';
import * as rolesActions from 'modules/roles/action';

import { FORM_ROLES } from 'modules/forms/formConstants';
import { CheckBoxFieldF} from 'modules/forms/component';

moment.locale('es');

@connect( store => ({
  roles: store.getIn(['roles','lista']),
  rolesUser: store.getIn(['roles','rolesUser']),
  userRoles: store.getIn(['user','roles']),
}))
class Add extends React.Component {
  componentDidMount = () => {
    this.props.dispatch(generalActions.dashboard_changeTitle('Modificando Roles'));
    this.props.dispatch(rolesActions.getRolesUser(this.props.params.id));
    if(this.props.userRoles && this.props.userRoles.find(v => v == 'admin' || v == 'devAdmin'))
     this.props.dispatch(rolesActions.get());
  }
  componentWillUnmount = () => this.props.dispatch(rolesActions.clear('rolesUser'))
  componentWillReceiveProps = nextProps => {
    if(nextProps.rolesUser != this.props.rolesUser){
      nextProps.rolesUser.map( rol => this.props.change(rol.get('roleId'), true));
    }
    if(nextProps.userRoles && this.props.userRoles != nextProps.userRoles && nextProps.userRoles.find(v => v == 'admin' || v == 'devAdmin'))
       this.props.dispatch(rolesActions.get());
  }
  submitForm = data => {
    data = formatData(data.toJS());
    this.props.dispatch(rolesActions.set(this.props.params.id, data));
  }
  render() {
    const { roles, userRoles } = this.props;
    const { nombre, apellido } = this.props.params;
    return (
      <div>
        <MaterialUI.Paper zDepth={2} className="container">
          <form onSubmit={this.props.handleSubmit(this.submitForm)}>
            <Row className="rowContainer baseline">
              <Col md={{size: 6, offset: 3}}>
                <MaterialUI.Paper zDepth={2} className="container">
                  <h3>{nombre} {apellido}</h3>
                </MaterialUI.Paper>
              </Col>
            </Row>
            <Row className="rowContainer baseline">
              <Col md={{size: 6, offset: 3}}>
                <MaterialUI.Paper zDepth={2} className="container">
                  <MaterialUI.List>
                    {roles.map( rol => {
                      if(rol.get('name') == 'admin' && userRoles && !userRoles.find(v => v == 'devAdmin')) return null;
                      return <MaterialUI.ListItem key={rol.get('id')}
                        className="noPadding textCenter"
                        leftCheckbox={
                          <Field
                            name={rol.get('id')}
                            inputProps={{
                              label: rol.get('name')
                            }}
                            component={CheckBoxFieldF}
                          />
                        }
                      />;}
                  )}
                  </MaterialUI.List>
                </MaterialUI.Paper>
              </Col>
              <MaterialUI.RaisedButton
                className="fullWidthComponent noPadding m-tb-20"
                label="GUARDAR"
                primary={true}
                type="submit"/>
            </Row>
          </form>
        </MaterialUI.Paper>
        <CancelarButtonC className="m-tb-20" dispatch={this.props.dispatch} />
      </div>);
      }
}

export default reduxForm({
  form: FORM_ROLES,
  enableReinitialize: true
})(Add);

const formatData = data => {
  let keysData = Object.keys(data);
  return keysData.filter( value => data[value] == true );
};



// WEBPACK FOOTER //
// src/modules/roles/components/add.js